import { render, staticRenderFns } from "./Record.vue?vue&type=template&id=49f8d0fa&scoped=true&"
import script from "./Record.vue?vue&type=script&lang=js&"
export * from "./Record.vue?vue&type=script&lang=js&"
import style0 from "./Record.vue?vue&type=style&index=0&id=49f8d0fa&prod&lang=scss&scoped=true&"
import style1 from "./Record.vue?vue&type=style&index=1&id=49f8d0fa&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f8d0fa",
  null
  
)

export default component.exports